import React from 'react';
import {AutoComplete, Input} from "antd";

const SearchInput = ({value, queries, onChange, handleSearch, clearSearch}) => {
    const options = value ? queries && queries.map(item => ({ value: item})) : []

    const filterOptions = (inputValue, option) =>
        option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1

    return (
        <AutoComplete
            value={value}
            style={{ width: 1400 }}
            defaultOpen={false}
            options={options}
            filterOption={filterOptions}
            onSelect={handleSearch}
            onChange={onChange}
        >
            <Input
                placeholder="Введите запрос"
                onPressEnter={(e) => handleSearch(e.target.value)}
                onClear={clearSearch}
                allowClear
            />
        </AutoComplete>
    )
};

export default SearchInput;
